import { datadogRum } from "@datadog/browser-rum";
import { addNextjsError } from "@datadog/browser-rum-nextjs";

import { isDatadogRumEnabled } from "./rum-config";

/** Browser-only Datadog capture (no dd-trace — safe for client bundles). */
export const captureException = (error, context) => {
  if (!isDatadogRumEnabled()) return null;

  if (error?.digest != null) {
    addNextjsError(error);
  } else {
    datadogRum.addError(error, context);
  }

  return null;
};

export const setDatadogUser = (user) => {
  if (!isDatadogRumEnabled()) return null;
  datadogRum.setUser(user);
  return null;
};

export const captureReactException = (error, errorInfo, options) => {
  if (!isDatadogRumEnabled()) {
    return null;
  }

  // App Router / RSC digest errors — Next.js-specific helper
  if (error?.digest != null) {
    addNextjsError(error, errorInfo);
    return null;
  }

  const err = error instanceof Error ? error : new Error(String(error));
  const renderingError = new Error(err.message);
  renderingError.name = "ReactRenderingError";
  renderingError.stack = errorInfo?.componentStack ?? err.stack;
  renderingError.cause = err;

  datadogRum.addError(renderingError, {
    ...options,
    componentStack: errorInfo?.componentStack,
  });
  return null;
};

/** Next.js App Router / global-error reporting (Datadog RUM wizard). */
export const reportAppError = (error) => {
  if (!isDatadogRumEnabled()) return null;
  addNextjsError(error);
  return null;
};
